import React from 'react';
import 'assets/styles/_commonSpacing.scss';

import {
  AuCallout,
  AuControlInput,
  AuHeading
} from 'components/DTA';

interface ICasaDeclaration {
  id: string;
  type?: string;
}

const CasaDeclaration: React.FC<ICasaDeclaration> = ({ id = 'declaration', type = 'application' }) => {
  const privacyType = type === 'authority' ? 'authorisation' : type;
  return (
    <AuCallout title='Declaration'>
      <div className="casa-padding-top--small">
        <strong>I declare:</strong>
        <ul className="casa-margin-top--zero">
          <li>All statements in this {type} are true and correct.</li>
        </ul>
        <p>I acknowledge by logging into the myCASA portal and submitting this {type}:</p>
        <ul className="casa-margin-top--zero">
          <li>This satisfies the requirement for me to sign this {type}.</li>
          <li>I may commit an offence under the Criminal Code Act 1995 if I make a false or misleading statement in my {type}.</li>
          <li>We may also use your licensing information in deidentified form for aviation safety research/analysis.</li>
        </ul>
        <AuHeading level="2" size="sm">Privacy</AuHeading>
        Any personal information you provide to CASA, as part of this {type}, is protected by the Privacy Act 1988.
        <p>We will use the information provided to process this {privacyType} and may also use it to conduct identity/security checks. Without your consent, we may not be able to process your {privacyType}.</p>
        <p>To meet our accountability obligations, we may disclose this information:</p>
        <ul className="casa-margin-top--zero">
          <li>to other government agencies or other national aviation authorities for certain purposes, and</li>
          <li>to comply with court orders and other legal requirements.</li>
        </ul>
        <p>For more information about how we use, disclose and protect your personal information, see our <a href="https://www.casa.gov.au/about-us/who-we-are/about-casa/privacy-statement" target='_blank' rel='noopener noreferrer'>privacy statement</a>, <a href='https://www.casa.gov.au/sites/default/files/2021-06/casa-privacy-policy.pdf' target='_blank' rel='noopener noreferrer'>privacy policy</a> and <a href='https://www.casa.gov.au/resources-and-education/our-systems/mycasa-portal/mycasa-terms-and-conditions' target='_blank' rel='noopener noreferrer'>myCASA terms and conditions</a>.</p>
      </div>
      <AuControlInput
        name={id}
        id={id}
        type='checkbox'
        label={
          <ul className="casa-margin-top--zero">
            <li>I declare and acknowledge the above matters.</li>
            <li>I consent to CASA using my licensing information and other personal information for the above purposes.</li>
            <li>I have read CASA&apos;s privacy policy and I authorise CASA to use and disclose the information it collects for this {type} in accordance with that policy.</li>
          </ul>
        }
        block
      />
    </AuCallout>
  );
};

export default CasaDeclaration;